var module = angular.module('octopusApp.configuration');

module.controller('LicenseIndexController', function($scope, busy, octopusRepository, unsavedChanges, $location, $window) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

    $scope.license = null;
    $scope.config = null;

    $scope.configUpdated = $location.search().configUpdated;

    var loadingPromises = [];
    loadingPromises.push(octopusRepository.Licenses.getCurrent().then(function (license) {
        $scope.license = license;
    }));
    loadingPromises.push(octopusRepository.UpgradeConfiguration.get().then(function (config) {
        $scope.config = config;
    }));
    isLoading.promises(loadingPromises).then(function () {
        // Move along, nothing to see here.
    });

    $scope.editorLoaded = function(editor) { 
        editor.getSession().setMode("ace/mode/xml");
        editor.$blockScrolling = Infinity;
    }

    $scope.save = function () {
        var savingPromises = [];
        savingPromises.push(octopusRepository.Licenses.save($scope.license).then(function (saved) {
            $scope.configSaved = true;
        }));

        savingPromises.push(octopusRepository.UpgradeConfiguration.modify($scope.config).then(function (saved) {
            $scope.configSaved = true;
        }));
        isSaving.promises(savingPromises).then(function () {
            unsavedChanges.saved();
            var url = $location.path();
            if ($scope.configSaved) {
                $location.path(url).search('configUpdated', 'true');
            }
            $window.location.reload();
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/license/controllers/license_index_controller.js
// module id = 3178389345588915
// module chunks = 1